import Print from '../src/Print/index.tsx';
export default Print;
